import {
    MetaPhoneNumber,
    MetaWaba,
    MetaWhatsAppNumberPolicyPhone,
    WhatsAppPhoneState,
    WhatsAppWabaStatus,
} from '@/types';

export const isPhoneEnabled = (phone: MetaWhatsAppNumberPolicyPhone | null) =>
    phone?.approvalStatus === 'APPROVED';

// Meta registration and Mobcall enablement are independent; only both together operate.
export const phoneState = (phone: MetaWhatsAppNumberPolicyPhone | null): WhatsAppPhoneState => {
    if (!phone) return WhatsAppPhoneState.UNKNOWN;
    const enabled = isPhoneEnabled(phone);
    if (phone.isActive) {
        return enabled ? WhatsAppPhoneState.OPERATING : WhatsAppPhoneState.NOT_ENABLED;
    }
    return enabled ? WhatsAppPhoneState.AWAITING_META : WhatsAppPhoneState.INACTIVE;
};

export const isPhoneOperating = (phone: MetaPhoneNumber) =>
    phone.isActive && phone.registrationStatus === 'REGISTERED';

export const operatingPhoneCount = (waba: MetaWaba) =>
    waba.phoneNumbers.filter(isPhoneOperating).length;

export const wabaStatus = (waba: MetaWaba): WhatsAppWabaStatus => {
    if (waba.disconnectedAt) return WhatsAppWabaStatus.DISCONNECTED;
    if (waba.status !== 'connected') return WhatsAppWabaStatus.AWAITING_ACTIVATION;
    return operatingPhoneCount(waba) ? WhatsAppWabaStatus.ACTIVE : WhatsAppWabaStatus.READY;
};
